import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const baseURL = "";

export default class HeaderService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getPersonalInfo(queryForm: any): Promise<any> {
    let token = localStorage.getItem("token");

    const headers = {
      "X-Token-QLTP": token,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/search`, queryForm, { headers })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public revoke(): Promise<any> {
    let token = localStorage.getItem("token");

    const headers = {
      "X-Token-QLTP": token,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/revoke`, { headers })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
